import React, { useEffect, useState } from 'react';

import { ButtonUI, DatagridPremiumUi, DialogUI } from '../Interface';
import dayjs from 'dayjs';
import { dataGridPremiumColumns } from '../../utils/helper';
import { Box } from '@mui/material';
import { extractCopyPayload } from '../../utils/DocHelper';

const SourceDocLineTableDialog = (props) => {
  const {
    open,
    onClose,
    docName,
    data,
    sourceDatagridIdentifiers,
    docTypeId,
    setSelectedValues,
    sourceHeaderValues,
  } = props;

  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  useEffect(() => {
    setRowSelectionModel(data?.docLine?.map((row) => `${row.docId}-${row.lineNum}`));
  }, [data, open]);

  const columns = dataGridPremiumColumns([
    {
      field: 'docNum',
      headerName: 'Bizonylatszám',
      type: 'string',
      filterable: false,
    },
    {
      field: 'reference',
      headerName: 'Hivatkozási szám',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        const ref = data.row.reference ?? '';
        const itemRef = data.row.itemReference ?? '';
        return itemRef ? `${ref} - ${itemRef}` : ref;
      },
    },
    {
      field: 'dueDate',
      headerName: 'Határidő',
      type: 'date',
      filterable: false,
      valueGetter: (_data, row) => {
        return new Date(row.dueDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.dueDate).format('YYYY-MM-DD');
      },
    },
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
      filterable: false,
    },
    {
      field: 'itemName',
      headerName: 'Cikkmegnevezés',
      type: 'string',
      filterable: false,
    },
    {
      field: 'qty',
      headerName: 'Mennyiség',
      type: 'number',
      filterable: false,
    },
    {
      field: 'opnQty',
      headerName: 'Nyitott mennyiség',
      type: 'number',
      filterable: false,
    },
    {
      field: 'quantityUnitCode',
      headerName: 'me',
      type: 'string',
      filterable: false,
    },
    {
      field: 'unitPrice',
      headerName: 'Egységár',
      type: 'number',
      filterable: false,
    },
    {
      field: 'netPrice',
      headerName: 'Nettó érték',
      type: 'number',
      filterable: false,
    },
    {
      field: 'currencyCode',
      headerName: 'Pénznem',
      type: 'string',
      filterable: false,
    },
    {
      field: 'weight',
      headerName: 'Súly',
      type: 'number',
      filterable: false,
    },
    {
      field: 'whsCode',
      headerName: 'Raktár',
      type: 'string',
      filterable: false,
    },
    {
      field: 'projectId',
      headerName: 'Projekt',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.project?.projectName;
      },
    },
    {
      field: 'costCenterCode',
      headerName: 'Költséghely',
      type: 'string',
      filterable: false,
    },
    {
      field: 'itemCodeInBp',
      headerName: 'ÜP cikkszám',
      type: 'string',
      filterable: false,
    },
    {
      field: 'internalNote',
      headerName: 'Belső megjegyzés',
      type: 'string',
      filterable: false,
    },
    {
      field: 'bpNote',
      headerName: 'ÜP megjegyzés',
      type: 'string',
      filterable: false,
    },
  ]);

  const handleSelectRows = () => {
    const docLine = data.docLine.filter((row) => rowSelectionModel.includes(`${row.docId}-${row.lineNum}`));
    const selectedValues = {
      ...data,
      docLine,
    };
    const payload = extractCopyPayload(selectedValues, parseInt(docTypeId));
    const normalizedPayload = payload
      ? {
          ...payload,
          ...sourceHeaderValues,
          preserveCopiedDates: true,
          docLine: (payload.docLine ?? []).map((line, index) => ({
            ...line,
            visOrder: index + 1,
          })),
        }
      : payload;

    setSelectedValues(normalizedPayload);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={docName} maxWidth="xl" fullWidth>
      <DatagridPremiumUi
        datagridIdentifier={sourceDatagridIdentifiers.sourceDocLine}
        datagridInitialState={{ density: 'compact' }}
        rows={data.docLine}
        hideFooter
        height={700}
        columns={columns}
        headerFilters={false}
        paginationAndfilterMode="client"
        checkboxSelection
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newModel) => setRowSelectionModel(newModel)}
        getRowId={(row) => `${row.docId}-${row.lineNum}`}
      />

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI
          text="Adatok átvétele"
          className="bg-success"
          onClick={handleSelectRows}
          disabled={rowSelectionModel?.length === 0}
        />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default SourceDocLineTableDialog;
